export const isStaffSummaryId = (value) => typeof value === "string" ?
    value.trim() !== "" && value === value.trim() : Number.isSafeInteger(value) && value >= 0;

export const isStaffSummaryCount = (value) => Number.isSafeInteger(value) && value >= 0;

const failure = () => Object.assign(new Error("Staff summary response is unavailable"), {
    code: "STAFF_SUMMARY_UNCONFIRMED"
});
const validCompany = (company) => company && isStaffSummaryId(company.id) &&
    (company.title === null || typeof company.title === "string");

// Booking rows are a complete event relation, not a page of workers. Reject
// duplicate/partial rows rather than silently creating an incorrect total.
export const parseStaffSummaryEvent = (event, { eeId, companyId = "", includeCheckedIn = true }) => {
    if (!isStaffSummaryId(eeId) || !isStaffSummaryId(event?.id) || String(event.id) !== String(eeId) ||
        (companyId !== "" && !isStaffSummaryId(companyId)) ||
        !Array.isArray(event.relBookedWorkersSubcontractors) || !Array.isArray(event.getAppWorkerSubcontractors)) {
        throw failure();
    }

    const companies = new Map();
    event.getAppWorkerSubcontractors.forEach((company) => {
        if (!validCompany(company) || companies.has(String(company.id))) throw failure();
        companies.set(String(company.id), { id: String(company.id), title: company.title });
    });

    const bookingIds = new Set();
    const bookedCompanies = new Set();
    let bookedCount = 0;
    event.relBookedWorkersSubcontractors.forEach((booking) => {
        if (!booking || !isStaffSummaryId(booking.id) || !isStaffSummaryId(booking.subcontractor_id) ||
            !isStaffSummaryCount(booking.booked_workers) || !validCompany(booking.relSubcontractor) ||
            String(booking.subcontractor_id) !== String(booking.relSubcontractor.id)) throw failure();
        const id = String(booking.id);
        const company = String(booking.subcontractor_id);
        if (bookingIds.has(id) || bookedCompanies.has(company)) throw failure();
        bookingIds.add(id);
        bookedCompanies.add(company);
        if (companyId === "" || String(companyId) === company) bookedCount += booking.booked_workers;
        if (!Number.isSafeInteger(bookedCount)) throw failure();
        const existing = companies.get(company);
        companies.set(company, {
            id: company,
            title: existing?.title || booking.relSubcontractor.title
        });
    });

    const checkedInCount = includeCheckedIn ? event.getAppCheckedInWorkersCount : null;
    if (includeCheckedIn && !isStaffSummaryCount(checkedInCount)) throw failure();

    return {
        bookedCount,
        checkedInCount,
        difference: includeCheckedIn ? checkedInCount - bookedCount : null,
        companies: Array.from(companies.values())
    };
};
